/*
    Made by : Samuel
    date :
    Updated: April 23, 2025
 */

// ----------------------------------------------------------------------------- //
// IMPORTS //

import { useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import styles from "./home.module.css";

import { ThemeContext } from "../../App";
import Header from "../../components/Home/Header/Header";
import Section from "../../components/Home/Section/Section";
import Carousel from "../../components/Home/Carousel/Carousel";
import FAQ from "../../components/Home/FAQ/FAQ";
import Sponsors from "../../components/Home/Sponsors/Sponsors";
import Footer from "../../components/Home/Footer/Footer";

// ----------------------------------------------------------------------------- //
// COMPONENT //

function Home() {
    const { isDarkMode } = useContext(ThemeContext);

    return (
        <div className={isDarkMode ? "theme-dark" : "theme-light"}>
            <Header />
            <div className={styles["hero-section"]}>
                <div className={styles.overlay}></div>
                <video
                    autoPlay
                    muted
                    loop
                    className={styles["background-video"]}>
                    <source src="/background.mp4" type="video/mp4" />
                </video>
                <div className={styles["hero-content"]}>
                    <h1
                        className="display-4 mb-4"
                        style={{
                            color: "#FFA500",
                            zIndex: 2,
                            position: "relative",
                            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                        }}>
                        <span style={{ color: "#E65A25" }}>BOT</span>{" "}
                        <span style={{ color: "#04528A" }}>POMBAL</span>
                    </h1>
                    <p className="lead mb-4">Competição de Robótica 2025</p>
                    <p className="lead mb-4">9 de Maio 2025</p>
                    <a
                        href="https://forms.office.com/pages/responsepage.aspx?id=7LQcGTSomkmCEswrr9kJj8K77XkhkpRCmlISEz_QGctUNVJSTlFZM0VXTkdLRzhWTEhCQVk1UFI2NS4u&route=shorturl"
                        className="btn btn-primary btn-lg rounded-pill">
                        Inscreva-se Agora
                    </a>
                </div>
            </div>

            <div className="container my-5">
                <Section id="info" title="Bem-vindo ao BotPombal">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            {/* <p className="lead">
                                Junte-se a nós para um evento emocionante cheio de desafios, inovação e diversão!
                                Compita com os melhores e mostre suas habilidades em uma variedade de desafios únicos de
                                robótica.
                            </p> */}
                            <p className="lead">
                                O BotPombal é uma competição de robótica
                                organizada pelo Clube de Robótica do Agrupamento
                                de Escolas de Pombal, que se realizará no
                                próximo dia 9 de maio de 2025, no átrio da
                                Escola Secundária de Pombal. Trata-se de um
                                evento pedagógico e formativo, destinado a
                                alunos dos 10 aos 15 anos (2.º e 3.º ciclos do
                                Ensino Básico), promovido num ambiente de
                                competição saudável, que incentiva o espírito de
                                equipa e a entreajuda. Cada equipa deverá ter
                                obrigatoriamente um nome, ser composta por três
                                elementos e poderá contar com a participação de
                                um docente ou mentor.
                            </p>
                            <div className="mt-4">
                                <a
                                    href="https://forms.office.com/pages/responsepage.aspx?id=7LQcGTSomkmCEswrr9kJj8K77XkhkpRCmlISEz_QGctUNVJSTlFZM0VXTkdLRzhWTEhCQVk1UFI2NS4u&route=shorturl"
                                    className="btn btn-outline-primary rounded-pill me-3">
                                    Inscreva-se Agora
                                </a>
                                <a href="#challenges" className="btn btn-link">
                                    Ver Desafios →
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-4 mt-lg-0">
                            <img
                                src="/BotPombal25.png"
                                alt="Logo da Competição"
                                className="img-fluid rounded"
                            />
                        </div>
                    </div>
                </Section>

                <Section id="challenges" title="Desafios">
                    <div className="row g-4 justify-content-center">
                        {[
                            {
                                title: "Segue Linha com obstáculos",
                                description:
                                    "Programa o robô para seguir uma linha enquanto evita obstáculos no caminho.",
                                icon: "🚗",
                            },
                            {
                                title: "Corrida de Velocidade",
                                description:
                                    "Programa o robô para completar um percurso o mais rápido possível.",
                                icon: "🏎️",
                            },
                        ].map((challenge, index) => (
                            <div className="col-md-4" key={index}>
                                <div
                                    className={`card h-100 border-0 ${
                                        styles.challengeCard
                                    } ${
                                        isDarkMode
                                            ? styles.darkCard
                                            : styles.lightCard
                                    }`}>
                                    <div className="card-body d-flex flex-column">
                                        <div className={styles.challengeIcon}>
                                            {challenge.icon}
                                        </div>
                                        <h5 className="card-title text-center">
                                            {challenge.title}
                                        </h5>
                                        <p className="card-text flex-grow-1 text-center">
                                            {challenge.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <br />

                    {/* button */}
                    <div className="text-center mt-4">
                        <a
                            href="/Regulamentos.pdf"
                            className="btn btn-outline-primary rounded-pill">
                            Regulamentos
                        </a>
                    </div>
                </Section>

                <Section id="prizes" title="Prémios">
                    <p className="lead text-center mb-4">
                        Todas as equipas participantes serão premiadas, com
                        prémios especiais para os vencedores.
                    </p>

                    <div className="row g-4 justify-content-center">
                        <div className="col-12 col-md-8 col-lg-6 mb-4">
                            <div
                                className={`card h-100 border-0 ${
                                    styles.prizeCard
                                } ${styles.firstPlace} ${
                                    isDarkMode
                                        ? styles.darkCard
                                        : styles.lightCard
                                } ${styles.firstPlaceCard}`}>
                                <div className="card-body d-flex flex-column align-items-center">
                                    <div className={styles.prizeIcon}>🏆</div>
                                    <h5 className="card-title text-center">
                                        1º Lugar
                                    </h5>
                                    <p className="card-text flex-grow-1 text-center">
                                        Troféu de 1º lugar.
                                    </p>
                                    {/* add a button */}
                                    <div className="mt-3">
                                        <a
                                            href="https://www.ptrobotics.com/kit-arduino/8893-kit-de-braco-robotico-4dof-diy-para-arduino-keyestudio.html"
                                            className="btn btn-outline-primary rounded-pill">
                                            Kitde Braço Robótico
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-100"></div>

                        <div className="col-md-5">
                            <div
                                className={`card h-100 border-0 ${
                                    styles.prizeCard
                                } ${styles.secondPlace} ${
                                    isDarkMode
                                        ? styles.darkCard
                                        : styles.lightCard
                                }`}>
                                <div className="card-body d-flex flex-column align-items-center">
                                    <div className={styles.prizeIcon}>🥈</div>
                                    <h5 className="card-title text-center">
                                        2º Lugar
                                    </h5>
                                    <p className="card-text flex-grow-1 text-center">
                                        Troféu de 2º lugar.
                                    </p>
                                    <div className="mt-3">
                                        <a
                                            href="https://www.botnroll.com/en/others/3431-funduino-starter-kit-with-uno-r3-compatible.html"
                                            target="_blank"
                                            className="btn btn-outline-primary rounded-pill">
                                            Arduino Starter Kit
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-5">
                            <div
                                className={`card h-100 border-0 ${
                                    styles.prizeCard
                                } ${styles.thirdPlace} ${
                                    isDarkMode
                                        ? styles.darkCard
                                        : styles.lightCard
                                }`}>
                                <div className="card-body d-flex flex-column align-items-center">
                                    <div className={styles.prizeIcon}>🥉</div>
                                    <h5 className="card-title text-center">
                                        3º Lugar
                                    </h5>
                                    <p className="card-text flex-grow-1 text-center">
                                        Troféu de 3º lugar e um prémio.
                                    </p>
                                    <div className="mt-3">
                                        <a
                                            href="/Regulamentos.pdf"
                                            className="btn btn-outline-primary rounded-pill">
                                            Prémio de 3º Lugar
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mt-5 text-center">
                        <div
                            className={`card border-0 ${
                                isDarkMode ? styles.darkCard : styles.lightCard
                            }`}>
                            <div className="card-body">
                                <div className={styles.prizeIcon}>🎁</div>
                                <h5 className="card-title">
                                    Para Todos os Participantes
                                </h5>
                                <p className="card-text">
                                    Todas as equipas receberão certificados de
                                    participação, medalhas, t-shirts e reforço
                                    alimentar durante o evento.
                                </p>
                            </div>
                        </div>
                    </div>
                </Section>

                <Section id="carousel" title="Galeria">
                    <p className="lead text-center mb-4">
                        Veja alguns dos melhores momentos de nossas competições
                        anteriores!
                    </p>
                    <Carousel />
                </Section>

                <Section id="location" title="Localização do Evento">
                    <div className={styles.mapContainer}>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.0046239700405!2d-8.626430132473056!3d39.91891272192916!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd22666502fd349f%3A0x8c15d52edae73b2b!2sAgrupamento%20de%20Escolas%20de%20Pombal!5e0!3m2!1spt-PT!2spt!4v1745423600624!5m2!1spt-PT!2spt"
                            width="100%"
                            height="450"
                            style={{ border: 0 }}
                            allowFullScreen={true}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                    <div className="text-center mt-4">
                        <p className="lead">
                            Escola Secundária de Pombal, 9 de Maio de 2025
                        </p>
                        <a
                            href="https://maps.app.goo.gl/UHyjmHkoTHBPUVJC9"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-primary rounded-pill mt-2">
                            <span className={styles.mapIcon}>📍</span> Ver no
                            Google Maps
                        </a>
                    </div>
                </Section>

                <Section id="faq" title="Perguntas Frequentes">
                    <FAQ />
                </Section>

                <Section id="sponsors" title="Os Nossos Patrocinadores">
                    <center>
                        <p>
                            Estamos orgulhosos de contar com o apoio dos nossos
                            patrocinadores. Se deseja se tornar um patrocinador,
                            pode entrar em contacto via Email
                        </p>
                    </center>
                    <br />
                    <Sponsors />
                </Section>
            </div>

            <Footer />
        </div>
    );
}

// ----------------------------------------------------------------------------- //
// EXPORTS //

export default Home;

// ----------------------------------------------------------------------------- //
